<template>
  <vue-accessible-datepicker
    :label="label"
    :calendarIcon="require('@/assets/images/calendar/calendar.svg')"
    :navigate-month-icons="{
      next: require('@/assets/images/calendar/next-arrow.svg'),
      previous: require('@/assets/images/calendar/back-arrow.svg'),
    }"
    :custom-classes="{
      toggleButtonIcon: 'calendar-icon',
      input: 'input-field',
      inputWrapper: 'input-container',
    }"
    dateFormat="DD/MM/YYYY"
    @input-change="inputDate"
    :required="required"
    :name="name"
  />
</template>

<script>
export default {
  name: 'accessible-datepicker',
  props: {
    required: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    inputDate(date) {
      this.$emit('input-date', date);
    },
  },
  mounted() {
    const label = document.getElementById('datepickerLabel');
    const input = document.getElementById('datepicker');
    const calendar = document.getElementById('datepicker-toggle-button');
    label.removeAttribute('id');
    label.removeAttribute('for');
    label.setAttribute('for', `${this.name}`);
    input.removeAttribute('id');
    input.setAttribute('id', this.name);
    calendar.removeAttribute('id');
    calendar.setAttribute('id', `${this.name}-button`);
  },
};
</script>

<style lang="scss">
.calendar-icon {
  width: 3em;
  height: 26px;
}

.input-field {
  padding: 0.7rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  width: 100%;
}

.input-container {
  width: 100%;
}
</style>
